import React from "react";
import {
  FaBalanceScale,
  FaCheckCircle,
  FaChartLine,
  FaFolderOpen,
  FaRobot,
} from "react-icons/fa";

function DetailedFeatures() {
  const details = [
    {
      title: "Controle juridico com leitura objetiva",
      description:
        "A home agora explica melhor como o sistema organiza a rotina do escritorio sem poluir a tela. Cada bloco reforca clareza, foco operacional e valor percebido.",
      bullets: [
        "Captura automatica de andamentos e prazos",
        "Historico consolidado de atividades e publicacoes",
        "Agenda com alertas e prioridade visual",
      ],
      icon: <FaBalanceScale className="text-gold fs-1" />,
      metric: "Processos e prazos em uma unica operacao",
      reverse: false,
    },
    {
      title: "IA posicionada como vantagem competitiva",
      description:
        "Em vez de parecer um recurso solto, a inteligencia artificial entra na narrativa da pagina como aceleradora de produtividade e consistencia tecnica.",
      bullets: [
        "Rascunhos e resumos mais rapidos",
        "Suporte a tarefas repetitivas com menos atrito",
        "Experiencia moderna alinhada a softwares premium",
      ],
      icon: <FaRobot className="text-gold fs-1" />,
      metric: "Produtividade aumentada com apoio inteligente",
      reverse: true,
    },
    {
      title: "Financeiro e performance com mais credibilidade",
      description:
        "A secao reforca que o EasyVOG nao e apenas um cadastro de processos. Ele ajuda a enxergar rentabilidade, tempo investido e saude do escritorio.",
      bullets: [
        "Fluxo de caixa, cobrancas e previsibilidade",
        "Timesheet conectado ao valor da operacao",
        "Indicadores para decisao gerencial",
      ],
      icon: <FaChartLine className="text-gold fs-1" />,
      metric: "Gestao financeira integrada ao juridico",
      reverse: false,
    },
  ];

  return (
    <section className="presentation-section">
      <div className="container presentation-shell px-4 px-lg-5 py-5">
        <div className="section-intro text-center mx-auto mb-5 pb-4">
          <span className="section-kicker">Diferenciais</span>
          <h2 className="section-title">Uma home mais forte em todos os blocos</h2>
          <p className="section-description section-description-muted">
            Reestruturei a area de detalhamento para deixar a narrativa mais
            moderna, visualmente premium e mais facil de converter.
          </p>
        </div>

        {details.map((detail, index) => (
          <div
            key={index}
            className={`row align-items-center g-4 mb-5 pb-lg-4 ${
              detail.reverse ? "flex-row-reverse" : ""
            }`}
          >
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className={`feature-detail-content ${detail.reverse ? "ms-lg-4" : "me-lg-4"}`}>
                <div className="feature-detail-badge">
                  {detail.icon}
                  <span>{detail.metric}</span>
                </div>
                <h2 className="display-6 fw-bold mb-4 text-dark">{detail.title}</h2>
                <p className="lead text-secondary mb-4">{detail.description}</p>
                <ul className="list-unstyled mb-0">
                  {detail.bullets.map((bullet, i) => (
                    <li key={i} className="mb-3 d-flex align-items-start feature-bullet-item">
                      <FaCheckCircle className="text-gold me-3 fs-5" />
                      <span className="text-secondary fw-semibold">{bullet}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="feature-detail-panel">
                <div className="feature-panel-header">
                  <span className="feature-panel-tag">Workspace</span>
                  <span className="feature-panel-status">Ativo</span>
                </div>

                <div className="feature-panel-stack">
                  <div className="feature-panel-card">
                    <FaFolderOpen className="text-gold fs-3" />
                    <div>
                      <strong>Base juridica organizada</strong>
                      <span>Clientes, processos, arquivos e prazos em uma mesma leitura.</span>
                    </div>
                  </div>

                  <div className="feature-panel-card">
                    {detail.icon}
                    <div>
                      <strong>{detail.metric}</strong>
                      <span>{detail.bullets[0]}</span>
                    </div>
                  </div>

                  <div className="feature-panel-card">
                    <FaChartLine className="text-gold fs-3" />
                    <div>
                      <strong>Visao gerencial</strong>
                      <span>Indicadores e acompanhamento para decisao mais rapida.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default DetailedFeatures;
